import React, { useState } from 'react';
import { Building2Icon, MenuIcon, SearchIcon, XIcon } from 'lucide-react';
type AppView = 'home' | 'results' | 'profile' | 'merchant';
type SiteHeaderProps = {
  view: AppView;
  onNavigate: (view: AppView) => void;
};
export function SiteHeader({
  view,
  onNavigate
}: SiteHeaderProps) {
  const [open, setOpen] = useState(false);
  const navigate = (next: AppView) => {
    onNavigate(next);
    setOpen(false);
  };
  return <header className="sticky top-0 z-30 border-b border-[#E5E5E5] bg-white/95 backdrop-blur" data-id="element-206" data-mp="uyr3pyy64s6c">
      <div className="mx-auto flex h-16 w-full items-center justify-between px-6 md:px-12 lg:px-16" data-id="element-207" data-mp="qy89xzcptc1i">
        <button type="button" onClick={() => navigate('home')} className="flex items-center gap-2 rounded-sm text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#008F82] focus-visible:ring-offset-2" aria-label="Pharmacy Pulse home" data-id="element-208" data-mp="14xzvqm9h3wq2">
          <span className="grid h-8 w-8 place-items-center bg-[#008F82] text-white" data-id="element-209" data-mp="2bc8x9kgn0n7y">
            <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 fill-none stroke-current stroke-[2.5]" data-id="element-210" data-mp="29jag39b6dw6a">
              <path d="M4 12h3l2-5 4 10 2-5h5" data-id="element-211" data-mp="2jhq7lde477gb" />
            </svg>
          </span>
          <span className="text-lg font-black tracking-tight text-[#1C1C1C]" data-id="element-212" data-mp="2ogt1c1on9r8z">
            Pharmacy<span className="text-[#008F82]" data-id="element-213" data-mp="1qtcaczuuof5t">Pulse</span>
          </span>
        </button>

        <nav className="hidden items-center gap-7 text-sm font-semibold text-[#4D4D4D] md:flex" aria-label="Primary navigation" data-id="element-214" data-mp="1qrho9i7ueh05">
          <button type="button" onClick={() => navigate('results')} className={view === 'results' ? 'text-[#008F82]' : 'hover:text-[#1C1C1C]'} data-id="element-215" data-mp="20qqeq13i1dhr">
            Find a pharmacy
          </button>
          <button type="button" onClick={() => navigate('home')} className="hover:text-[#1C1C1C]" data-id="element-216" data-mp="1d1e6b3fzx9gi">
            How it works
          </button>
          <button type="button" onClick={() => navigate('merchant')} className={view === 'merchant' ? 'text-[#008F82]' : 'hover:text-[#1C1C1C]'} data-id="element-217" data-mp="102erckdv7izj">
            For pharmacies
          </button>
        </nav>

        <div className="hidden items-center gap-3 md:flex" data-id="element-218" data-mp="19uask4b8zp7z">
          <button type="button" onClick={() => navigate('merchant')} className="rounded-sm px-3 py-2 text-sm font-bold text-[#008F82] hover:bg-[#F4F8F5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#008F82]" data-id="element-219" data-mp="m35cpp5b4wxo">
            Owner sign in
          </button>
          <button type="button" onClick={() => navigate('merchant')} className="rounded-full bg-[#E28743] px-4 py-2 text-sm font-bold text-white hover:bg-[#D07635] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E28743] focus-visible:ring-offset-2" data-id="element-220" data-mp="r3jmbbmk4ext">
            Claim a pharmacy
          </button>
        </div>

        <button type="button" onClick={() => setOpen(!open)} className="grid h-10 w-10 place-items-center rounded-sm border border-[#E5E5E5] text-[#1C1C1C] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#008F82] md:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-221" data-mp="2f0stoaaclt7h">
          {open ? <XIcon className="h-5 w-5" data-id="element-222" data-mp="2xrjx6v7nmpdy" /> : <MenuIcon className="h-5 w-5" data-id="element-223" data-mp="2jxj9cwi8qmsd" />}
        </button>
      </div>
      {open && <nav id="mobile-menu" className="border-t border-[#E5E5E5] bg-white px-4 py-3 md:hidden" aria-label="Mobile navigation" data-id="element-224" data-mp="2nyl718wieqs8">
          <div className="grid gap-1" data-id="element-225" data-mp="3ggqmx26v8h99">
            <button type="button" onClick={() => navigate('results')} className="flex items-center gap-3 rounded-sm px-3 py-3 text-left text-sm font-bold text-[#1C1C1C] hover:bg-[#F7F7F7]" data-id="element-226" data-mp="3ghrv8ywhypna">
              <SearchIcon className="h-4 w-4 text-[#A63A2B]" data-id="element-227" data-mp="1itfwuz67fsye" /> Find a pharmacy
            </button>
            <button type="button" onClick={() => navigate('merchant')} className="flex items-center gap-3 rounded-sm px-3 py-3 text-left text-sm font-bold text-[#008F82] hover:bg-[#F4F8F5]" data-id="element-228" data-mp="1esdyekk43kxh">
              <Building2Icon className="h-4 w-4" data-id="element-229" data-mp="26jttz43nchzu" /> Pharmacy owner dashboard
            </button>
          </div>
        </nav>}
    </header>;
}